import { FaMoneyBillWave,FaCoins} from "react-icons/fa";

const ExpenseList = ({ expenses, onDelete }) => {
    return (
        <div className="all-expenses-section my-4">
            <h3 className="fs-4 fw-bold mb-4">All Expenses</h3>

            {expenses.length === 0 && (
                <p className="text-muted">No expenses yet. Start tracking now!</p>
            )}

            {expenses.map((exp) => (
                <div
                    key={exp.id}
                    className="d-flex justify-content-between align-items-center bg-light border-start border-4 border-primary rounded shadow-sm p-3 mb-3 expense-item"
                >
                    <div className="d-flex align-items-start gap-3">
                        {/* Circular Icon Tile */}
                        <div className="expense-icon-tile d-flex justify-content-center align-items-center">
                            <FaCoins size={24} color="#da9e1dff" />
                        </div>


                        <div>
                            <h5 className="fw-semibold mb-1">{exp.title}</h5>
                            <span className="badge bg-secondary me-2">{exp.category}</span>
                            <small className="text-muted d-block mt-1">
                                {new Date(exp.date).toLocaleDateString()}
                            </small>
                        </div>
                    </div>

                    <div className="text-end">
                        <p className="mb-1 fw-bold text-success">₹{exp.amount.toFixed(2)}</p>
                        <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => onDelete(exp.id)}
                        >
                            <i className="bi bi-trash3 me-1"></i> Delete
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ExpenseList;
